import { Role } from "@/acl/roles";
import { PRODUCTS_DETAILS } from "@/assets/constants/products/thoendl";

export default {
  orgName: "Thoendl",
  logoPath: require("@/assets/images/logo/thoendl.svg"),
  navBarLogoStyle: "width: 100%; max-height: 150px;",
  allowedLoginMethods: ["Google"],
  products: PRODUCTS_DETAILS,
  possibleRoles: [Role.superAdmin, Role.admin],
  admin: true,
  availableLanguages: ["en"],
};
